import React, { useEffect, useState } from "react";
import { FaRegUserCircle } from "react-icons/fa";
import { SlCalender } from "react-icons/sl";
import "../Styles/blogdetails.css";
import Navbar from "../sections/common/Navbar";
import Footer from "../sections/common/Footer";
import Sidebar from "../components/Sidebar";
import { useLocation } from "react-router-dom";
import { blogDetailApi } from "../apis/blog/blogApis";

const BlogInner = () => {
    const location = useLocation()
    const [blogDetail, setBlogDetail] = useState(null)
    const blogId = location.pathname.split("/")[2].split("-").pop()
    console.log("location blog", location.pathname.split("/")[2].split("-").pop())

    const fetchBlogDetail = async () => {
        const response = await blogDetailApi(blogId);
        setBlogDetail(response)
        // console.log("response from fetchBlogDetail", response)
    }

    useEffect(() => {
        fetchBlogDetail()
    }, [])


    return (
        <>
            <div className="blog_details">
                <Navbar />
                <section className="listing-banner">
                    <h1>Blogs</h1>
                </section>
                <section className="container blog-details-page-location">
                    <p>Home / Blog-details</p>
                </section>

                <section className="container pb-5 ">
                    <div className="row pt-4">
                        <div className="col-sm-12 col-xxl-8">
                            <div className="blog_main_section">
                                <img src={blogDetail?.image || "/images/blog_image.png"} alt="image" />

                                <div className="px-3">
                                    <div className="blog-detail-title d-flex align-items-center justify-content-between my-3">
                                        <p className="m-0 p-0 blog_main_section_btn">Property</p>
                                        <div className="d-flex align-items-center justify-content-between blog_main_section_date">
                                            <div className="blog_main_section_date-top d-flex align-items-center mx-2">
                                                <svg className="mx-2" height="1em" width="1em">
                                                    <FaRegUserCircle className="mx-2" />
                                                </svg>
                                                <p className="m-0 p-0">Alphonsa Daniel</p>
                                            </div>
                                            <div className="blog_main_section_date-btn d-flex align-items-center">
                                                <svg className="mx-2" height="1em" width="1em">
                                                    <SlCalender className="mx-2" />
                                                </svg>
                                                <p className="m-0 p-0">Feb 6, 2023</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Blog Title and Description */}
                                    <div className="blog_main_title">
                                        <h3>{blogDetail?.title}</h3>
                                        <p dangerouslySetInnerHTML={{ __html: blogDetail?.description }}>

                                        </p>
                                    </div>

                                    {/* Comment Section */}
                                    {/* <div className="blog_comments my-5">
                                        <h4>Comments</h4>
                                        <div className="comment_form mt-3">
                                            <form action="#" method="post">
                                                <div className="form-group">
                                                    <label htmlFor="name">Name:</label>
                                                    <input
                                                        type="text"
                                                        id="name"
                                                        name="name"
                                                        className="form-control"
                                                    />
                                                </div>
                                                <div className="form-group pt-3">
                                                    <label htmlFor="comment">Comment:</label>
                                                    <textarea
                                                        id="comment"
                                                        name="comment"
                                                        className="form-control blog-comment"
                                                        defaultValue={""}
                                                    />
                                                </div>
                                                <button type="submit" className="btn btn-primary mt-4">
                                                    Submit
                                                </button>
                                            </form>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <Sidebar />
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default BlogInner;